"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import Link from "next/link";
import { NavUser } from "./nav-user";
import { UserOrNot } from "./user-or-not";
import { ModeToggle } from "@/components/light-dark-toggle";

export function LoginOrUserDesktop() {
  return (
    <UserOrNot
      userContent={(user) => (
        <div className="flex items-center gap-2">
          <ModeToggle />
          <NavUser user={user} />
        </div>
      )}
      noUserContent={
        <div className="flex items-center gap-4 justify-center animate-in fade-in duration-500">
          <ModeToggle />
          <Button asChild>
            <Link
              prefetch
              href={{ pathname: "/login", query: { redirectTo: "/me/api-keys" } }}
            >
              Log in / Sign up
            </Link>
          </Button>
        </div>
      }
    />
  );
}
